import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.FixturesAndResults = class FixturesAndResults extends Snappy.BaseComponent {
    static get tagName() {
        return 'fixtures-and-results';
    }

    constructor(element) {
        super(element);
    }

    render() {
        let wrapper = $(".fixtures-and-results");

        $('.scCompetitions').change(function () {
            fixturesAndResults.setCompetitionDetails(this);
        });

        $('.scSeasonYear').change(function () {
            fixturesAndResults.setSeasonDetails(this);
        });

        $(document).ready(function () {
            fixturesAndResults.setTabsvisibility();
            $(".fixtures-and-results .nav-buttons-wrap .nav-button").each(function (index) {
                $(this).on("click", function () {
                    $(".fixtures-and-results .nav-buttons-wrap .nav-button").removeClass('selected');
                    $(this).addClass('selected');
                    var selectedDropdown = $(".scCompetitions option:selected");
                    /*var showCalendar = selectedDropdown.attr("data-calendar");
                    var showBuyNow = selectedDropdown.attr("data-buynow");*/
                    var buttons = $(".fixtures-sub-btns-wrap");
                    if ($(this).hasClass('fixtures-btn')) {
                        $(".fixtures-and-results .fixtures-wrap").show();
                        $(".fixtures-and-results .results-wrap").hide();
                        buttons.find(".blue").show();
                    } else {
                        $(".fixtures-and-results .fixtures-wrap").hide();
                        $(".fixtures-and-results .results-wrap").show();
                        buttons.find(".blue").hide();
                    }

                    monthScroll();
                });
            });
            
            monthScroll();
            
            

            $(window).resize(function () {
                $('select').blur();
            });
            
            var results = $(".scResultMonthsList");
            var fixtures = $(".scFixtureMonthsList");
            if (results !== undefined && results.length > 0) {
                var firstResult = results.find("div.row_");
                if (firstResult !== undefined && firstResult.length > 0) {
                    var firstMonth = firstResult.siblings('.month-name');
                    $(".results-wrap .month-scroll div[data-set='" + firstMonth.attr('data-set') + "']").addClass("selected");
                }
            }
            if (fixtures !== undefined && fixtures.length > 0) {
                var firstfixture = fixtures.find("div.row_");
                if (firstfixture !== undefined && firstfixture.length > 0) {
                    var firstMonth = firstfixture.siblings('.month-name');
                    $(".fixtures-wrap .month-scroll div[data-set='" + firstMonth.attr('data-set') + "']").addClass("selected");
                }
            }

            $(document).on('click', ".fixtures-and-results .month", function () {
                $(this).parent().children().removeClass('selected');
                $(this).addClass('selected');
                monthScroll();
                
            });

            

            $(document).on('click', ".fixtures-wrap .month", function () {
                var mainDataSet = $(".scFixtureMonthsList div[data-set='" + $(this).attr('data-set') + "']").parent();
                if (mainDataSet.length > 0) {
                    mainDataSet.prevAll(".scFixtureMonthsList").addBack().hide();
                    mainDataSet.nextAll(".scFixtureMonthsList").addBack().show();
                    $("#appendedSorryFixtureMsg").remove();
                }
                else {
                    $(".scFixtureMonthsList").hide();
                    if ($("#appendedSorryFixtureMsg").length === 0)
                        $(".fixtures-wrap").append('<div style="margin-top: 10px;" id="appendedSorryFixtureMsg">' + $("#sorryMsg").val() + '</div> ');
                }

            });

            $(document).on('click', ".results-wrap .month", function () {
                var mainDataSet = $(".scResultMonthsList div[data-set='" + $(this).attr('data-set') + "']").parent();
                if (mainDataSet.length > 0) {
                    mainDataSet.prevAll(".scResultMonthsList").addBack().hide();
                    mainDataSet.nextAll(".scResultMonthsList").addBack().show();
                    $("#appendedSorryResultMsg").remove();
                }
                else {
                    $(".scResultMonthsList").hide();
                    if ($("#appendedSorryResultMsg").length === 0)
                        $(".results-wrap").append('<div style="margin-top: 10px;" id="appendedSorryResultMsg">' + $("#sorryMsg").val() + '</div> ');
                }
            });
        });

        wrapper.find($(".filters-toggle")).click(function () {
            wrapper.find($(".filters")).toggle();
        });

        
        function monthScroll() {
            $('.fixtures-and-results .month-wrap').each(function () {
                let monthSelected = $(this).find(".month.selected");
                $(this).animate({ scrollLeft: $(this).scrollLeft() + monthSelected.offset().left - ($(this).width() - 40) / 2 + monthSelected.width() / 2 }, 500);

            });
        }

        var CommonMethods = function () {

           var _getVerificationToken = function getVerificationToken(form) {
                return form.find('input[name=__RequestVerificationToken]').val();
            };

            return {
                getVerificationToken: _getVerificationToken
            };
        }();
        //******* Event registered to handle HTTP-POST & HTTP-GET *******
        var HttpService = function () {

            var _httpGet = function (serviceName, serviceDatatype, successCallback, errorCallback, sender) {
                var datatype = serviceDatatype !== "" ? serviceDatatype : "json";
                $.ajax({
                    url: '/api/sitecore/' + serviceName,
                    type: "GET",
                    dataType: datatype,
                    headers: {
                        "__RequestVerificationToken-FA": CommonMethods.getVerificationToken($('#subscribe-form'))
                    },
                    cache: false,
                    beforeSend: function () {
                        $(".loader").removeClass('hide');
                    },
                    success: function (data) {
                        successCallback(data, sender);
                    },
                    error: function (jqXHR, status, errorMessage) {
                        errorCallback(jqXHR);
                    },
                    complete: function () {
                        $(".loader").addClass('hide');
                    }
                });
            },

                _httpPost = function (serviceName, serviceDatatype, dataInput, successCallback, errorCallback, sender) {
                    var datatype = serviceDatatype !== "" ? serviceDatatype : "json";
                    $.ajax({
                        url: '/api/sitecore/' + serviceName,
                        type: "POST",
                        headers: {
                            "__RequestVerificationToken-FA": CommonMethods.getVerificationToken($('#subscribe-form'))
                        },
                        dataType: datatype,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function () {
                        },
                        success: function (data) {
                            successCallback(data, sender);
                        },
                        error: function (jqXHR, status, errorMessage) {
                            errorCallback(jqXHR);
                        },
                        complete: function () {
                        }
                    });
                };

            return {
                httpPost: _httpPost,
                httpGet: _httpGet
            };
        }();

        var fixturesAndResults = function () {
            var context = undefined;
            var _init = function (ref) {
                context = ref;
            };
           var _setSeasonDetails = function (ref) {
                var url = $("#divisionUrl").val() + "?seasonId=" + $(".scSeasonYear").val();
                HttpService.httpGet(url, 'html', _updateDivisionSeasonDropdown, ref);

            },
                _setCompetitionDetails = function (ref) {
                    var url = $("#fixtureDetailsUrl").val() + "?divisionSeasonId=" + $(".scCompetitions").val() + "&seasonId=" + $(".scSeasonYear").val();
                    HttpService.httpGet(url, 'html', _updatefixturesAndResultsForSeason, ref);
                },
                _setTabsvisibility = function (ref) {
                    _highlightMonth();
                    _convertFixtureTime();
                    var selectedTab = $(".nav-buttons-wrap .selected");
                    if (selectedTab.hasClass("fixtures-btn")) {
                        $(".fixtures-and-results .fixtures-wrap").show();
                        $(".fixtures-and-results .results-wrap").hide();
                    }
                    if (selectedTab.hasClass("results-btn")) {
                        $(".fixtures-and-results .fixtures-wrap").hide();
                        $(".fixtures-and-results .results-wrap").show();
                    }
                },
                _highlightMonth = function () {

                    var results = $(".scResultMonthsList");
                    var fixtures = $(".scFixtureMonthsList");
                    if (results !== undefined && results.length > 0) {
                        var firstResult = results.find("div.row_");
                        if (firstResult !== undefined && firstResult.length > 0) {
                            var firstMonth = firstResult.siblings('.month-name');
                            $(".results-wrap .month-scroll div[data-set='" + firstMonth.attr('data-set') + "']").addClass("selected");
                        }
                    }
                    if (fixtures !== undefined && fixtures.length > 0) {
                        var firstfixture = fixtures.find("div.row_");
                        if (firstfixture !== undefined && firstfixture.length > 0) {
                            var firstMonth = firstfixture.siblings('.month-name');
                            $(".fixtures-wrap .month-scroll div[data-set='" + firstMonth.attr('data-set') + "']").addClass("selected");
                        }
                    }
                },
                _convertFixtureTime = function () {
                    var fixturesTime = $(".fixtures-wrap .kickoff");
                    if (fixturesTime !== undefined && fixturesTime.length > 0) {
                        $.map(fixturesTime, function (dom, postion) {
                            var bothDevice = $(dom).find(".scInputMatchDate");
                            if (bothDevice !== undefined && bothDevice.length > 0) {
                                $.map(bothDevice, function (device, index) {
                                    var timeInUtc = $(device).val().replace(/-/g, "/") + ' UTC';
                                    var date = new Date(timeInUtc);
                                    $(dom).find(".scMatchDate").text(date.toTimeString().split(' ')[0].substr(0, 5));
                                });
                            }
                        });
                    }
                },
                _updatefixturesAndResultsForSeason = function (data, ref) {

                    $('#scMatchDetails').html(data);
                    _setTabsvisibility();
                },
                _updateDivisionSeasonDropdown = function (data, ref) {
                    var obj = JSON.parse(data);
                    if (obj != null) {
                        $('.scCompetitions').empty();
                        var buildHtml = '';
                        obj.forEach(function (i) {
                            buildHtml += '<option value="' + i.divisionSeasonID + '">' + i.publishedDivisionDesc + '</option>';
                        });
                        $('.scCompetitions').html(buildHtml);
                        _setCompetitionDetails();
                    }

                };
            return {
                init: _init,
                setSeasonDetails: _setSeasonDetails,
                setCompetitionDetails: _setCompetitionDetails,
                setTabsvisibility: _setTabsvisibility
            };

        }();

    };


}






// WEBPACK FOOTER //
// ./components/fixturesAndResults/scripts/fixtures-and-results.js